<!-- 网站首页 -->
<template>
  <div class="page_group bg_000000">
    <public-header :isfill='false'></public-header>
    <!-- <public-swiper></public-swiper> -->
    <public-vueSwiper :swiper_list='swiper_list' class="hidden-xs hidden-sm hidden-md">
      <public-footer slot="footer_pc"></public-footer>
    </public-vueSwiper>
    <public-vueSwiper :swiper_list='swiper_list' class="hidden-lg" type='h5'>
      <public-footer slot="footer_h5"></public-footer>
    </public-vueSwiper>

  </div>
</template>
<script>
  import {
    swiper_list
  } from '@/network/index.js';
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    data() {
      return {
        swiper_list: []
      }
    },
    created() {
      let that = this;
      that.get_swiper_list();
    },
    components: {},
    computed: {
      ...mapGetters('setting', ['GET_SCREEN'])
    },
    methods: {
      get_swiper_list() {
        //获取轮播图列表
        swiper_list({
          device: '',
          lang_type: '',
          banner_type: '',
          pageIndex: 1,
          pageSize: 1000
        }).then(res => {
          if (res.code === '0') {
            this.swiper_list = [...res.data.bannerModelList];
          }
        });
      } //end
    }
  }
</script>

<style scoped="scoped">
  .page_group {
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue